import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  subscription OnAgentConversationPublished(
    $tenantId: ID!
    $zoneId: ID!
    $agentId: String!
  ) {
    onAgentConversationPublished(
      tenantId: $tenantId
      zoneId: $zoneId
      agentId: $agentId
    ) {
      agentId
      createdAt
      id
      name
      tenantId
      workspaceId
      zoneId
      ownerId
      sharedWith
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.OnAgentConversationPublishedSubscription,
    ents.core.agent.Conversation,
    'onAgentConversationPublished'
  >(
    'onAgentConversationPublished',
    graphql.transformers.OUT.object({
      agentId: graphql.transformers.OUT.nonNull(
        common.gql.enums.agentId.TRANSFORMER,
      ),
      createdAt: graphql.transformers.OUT.validate(
        graphql.transformers.AWS_SCALARS.datetime,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
      id: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        PartialId.assertIsPartialId,
      ),
      name: {
        usingFullInput: graphql.transformers.OUT.nonNull(
          graphql.transformers.OUT.select('name', transformers.PASS_THROUGH),
        ),
      },
      ownerId: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
      ),
      sharedWith: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(transformers.PASS_THROUGH),
        [],
      ),
      workspaceId: {
        usingFullInput: graphql.transformers.OUT.select(
          'workspaceId',
          graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.Factory.from(
              TypeChecker.Factory.optional(PartialId.isPartialId),
            ),
          ),
        ),
      },
    }),
  ),
)

export const executor = graphql.createSubscriber<
  graphql.schema.OnAgentConversationPublishedSubscription,
  ents.core.agent.Conversation,
  graphql.schema.OnAgentConversationPublishedSubscriptionVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
